import { render, staticRenderFns } from "./section6.vue?vue&type=template&id=146e1b86&scoped=true&"
import script from "./section6.vue?vue&type=script&lang=js&"
export * from "./section6.vue?vue&type=script&lang=js&"
import style0 from "./section6.vue?vue&type=style&index=0&id=146e1b86&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146e1b86",
  null
  
)

export default component.exports